import PulseLoader from "react-spinners/PulseLoader";
import MoonLoader from "react-spinners/MoonLoader";
import { createPortal } from "react-dom";
import logo from "assets/img/logo.png";

import { StyledPaper, Wrapper } from "./Loading.style";
import { theme } from "styles/mui-config";

function LoadingCM({
  size = 10,
  color = theme.palette.primary.dark,
  isImg = false,
}) {
  if (isImg) {
    return <MoonLoader color={color} size={40} />;
  } else
    return createPortal(
      <Wrapper>
        <StyledPaper elevation={0}>
          <img src={logo} alt="logo" />
          {/* <pre>WE WELL</pre> */}
          <PulseLoader color={color} size={size} />
        </StyledPaper>
      </Wrapper>,
      document.getElementById("loading")
    );
}

export default LoadingCM;
